/**
 * Debug Logger - centralizes console output with a toggle.
 * In production builds, set DEBUG = false to silence all debug logs.
 */

let DEBUG = typeof window !== 'undefined' && (
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1'
);

export function setDebug(enabled: boolean): void {
  DEBUG = enabled;
}

export function debugLog(tag: string, ...args: unknown[]): void {
  if (DEBUG) {
    console.log(`[${tag}]`, ...args);
  }
}

export function debugWarn(tag: string, ...args: unknown[]): void {
  if (DEBUG) {
    console.warn(`[${tag}]`, ...args);
  }
}

/** Always logs errors regardless of DEBUG flag — errors should never be silenced */
export function debugError(tag: string, ...args: unknown[]): void {
  console.error(`[${tag}]`, ...args);
}
